export default "__VITE_ASSET__DspWqPKJ__"